import { useState, useEffect, useCallback } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useGetInvites = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInvites = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api_without_cancellation.get("/api/treatment-opt/invites/");
      setData(response.data);
      setError(null);
    } catch (err) {
      console.error(err);
    }
  }, []);

  // Auto-fetch on mount
  useEffect(() => {
    fetchInvites();
  }, [fetchInvites]);

  return { data, loading, error, fetchInvites };
};

export default useGetInvites;

const useGetCoCounsellingInvites = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCoCounsellingInvite = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api_without_cancellation.get("/api/list-firm-counsel-invites/");
      setData(response.data);
      setError(null);
    } catch (err) {
      console.error(err);
    }
  }, []);

  // Auto-fetch on mount
  useEffect(() => {
    fetchCoCounsellingInvite();
  }, [fetchCoCounsellingInvite]);

  return { data, loading, error, fetchCoCounsellingInvite };
};

export { useGetCoCounsellingInvites };

const useGetCasePageInvites = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCoCounsellingInvite = useCallback(async (queryParams = null) => {
    setLoading(true);
    try {
      let url = "/api/list-firm-counsel-invites/";
      if (queryParams && Object.keys(queryParams).length > 0) {
        const query = new URLSearchParams(queryParams).toString();
        url += `?${query}`;
      }

      const response = await api_without_cancellation.get(url);
      setData(response.data);
      setError(null);
    } catch (err) {
      console.error(err);
    }
  }, []);

  return { data, loading, error, fetchCoCounsellingInvite };
};

export { useGetCasePageInvites };
